/** 源站顶栏金额：无 `$`。整数不带小数，否则两位。入参是分。 */
export function formatOroMxAmount(minor: number): string {
  const major = Math.max(0, minor) / 100;
  if (Number.isInteger(major)) {
    return String(major);
  }
  return major.toFixed(2);
}

/** 顶栏现金/积分：一律向下取整到元。只改展示。 */
export function formatOroMxIntegerAmount(minor: number): string {
  const safe = Number.isFinite(minor) ? Math.max(0, minor) : 0;
  return String(Math.floor(safe / 100));
}

/** 源站金额：`$` 紧贴数字。整数不带小数，否则两位。入参是分。 */
export function formatOroMxMoney(minor: number): string {
  return `$${formatOroMxAmount(minor)}`;
}

/** 奖池货架 / 任务进度：源站 `2,000` 千分位。 */
export function formatOroMxGroupedAmount(minor: number): string {
  const raw = formatOroMxAmount(minor);
  const [intPart, dec] = raw.split('.');
  const grouped = (intPart ?? '0').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  return dec ? `${grouped}.${dec}` : grouped;
}

export function formatOroMxGroupedMoney(minor: number): string {
  return `$${formatOroMxGroupedAmount(minor)}`;
}

/** 带符号金额。0 不加正负号。 */
export function formatOroMxSignedMoney(minor: number): string {
  if (minor < 0) return `-${formatOroMxMoney(-minor)}`;
  if (minor > 0) return `+${formatOroMxMoney(minor)}`;
  return formatOroMxMoney(0);
}
